import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { MyProfileComponent } from '@app/shared/biq/my-profile/my-profile.component';
import { UnsavedChangesDialogComponent } from '@app/shared/biq/my-profile/unsaved-changes-dialog/unsaved-changes-dialog.component';

export const unsavedChangesGuard: CanDeactivateFn<MyProfileComponent> = (component) => {
  if (!component.isSaveBtnEnabled) {
    return true;
  }

  const dialog = inject(MatDialog);

  const dialogRef = dialog.open(UnsavedChangesDialogComponent, {
    panelClass: 'unsaved-changes-dialog',
    backdropClass: 'unsaved-changes-backdrop',
    width: '207px',
    disableClose: true,
  });

  return dialogRef.afterClosed().pipe(
    map((result) => {
      if (result === 'save') {
        component.saveUserInfo();
        return false;
      }
      return result === 'ignore';
    })
  );
};
